import { createApiActions } from '../../../helpers/actions';
import { Customer } from '../../../models';

export const fetchCustomer = createApiActions<Customer>()(
  'customer/fetch',
  'customer/fetchSuccess',
  'customer/fetchError',
  (customerId?: number, includeSysAdmins?: boolean) => ({ customerId, includeSysAdmins })
);
